import { Component } from 'js-component-framework';

/**
 * Component for instantiating Push Navigation
 */
export default class PushNavigation extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Elements
    this.pushNav = document.querySelector('.site-pushnav');
    this.open = document.querySelector('.site-nav__toggle');
    this.close = document.querySelector('.site-pushnav__toggle');
    this.page = document.querySelector('#page');

    // Initalizations
    this.toggleOn();
    this.toggleOff();
    this.triggerSubNav();
  }

  /**
   * Toggle state of push navigation to On
   */
  toggleOn() {
    this.open.addEventListener('click', () => {
      this.pushNav.classList.add(this.options.toggleActiveClass);
      this.page.classList.add('overlay-active');
    });
  }

  /**
   * Toggle state of push navigation to Off
   */
  toggleOff() {
    this.close.addEventListener('click', () => {
      this.pushNav.classList.remove(this.options.toggleActiveClass);
      this.page.classList.remove('overlay-active');
    });
  }

  /**
   * Trigger push nav sub-navigation
   */
  triggerSubNav() {
    Array.prototype.forEach.call(this.children.subNavTrigger, (el) => {
      el.addEventListener('click', () => {
        const parent = el.parentElement;
        const activeClass = this.options.subNavActiveClass;

        if (parent.classList.contains(activeClass)) {
          el.parentElement.classList.remove(this.options.subNavActiveClass);
          el.setAttribute('aria-expanded', 'false');
        } else {
          el.parentElement.classList.add(this.options.subNavActiveClass);
          el.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./client/js/components/Header/PushNavigation.js